// extracted by mini-css-extract-plugin
module.exports = {"nav":"Pagination_nav__2yWnQ","a":"Pagination_a__1FJdA","active":"Pagination_active__2BET6","a2":"Pagination_a2__3t7gC"};